// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"405":"component---src-pages-presentation-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"405":"38f4b9705dbb12f6a407","678":"d0a7e950d214e881b7f0","883":"2765b6a02314b9bdb50a"}[chunkId] + ".js";
};